import styled from "styled-components";


export const ButtonWrapper = styled.button`
    color: ${(props) => props.theme.color.primary};
    background-color: ${(props) => props.color ? props.color : props.theme.color.secondary};
    padding: 20px 30px;
    min-width: 300px;
    font-size: 1.5rem;
    margin: 20px;
    border: none;
    border-radius: 10px;
    font-weight: 200;
    ${(props) => props.theme.media.mobile} {
        min-width: 100px;
    }

    &:hover {
        box-shadow: 0px 0px 10px ${(props) => props.theme.color.purple};
        cursor: pointer;
    }
`